/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';

export namespace IceTypes {
    export enum ACCOUNT_TYPE {
        actNone = 0,
        actFacility = 1,
        actProvider = 2,
        actPatient = 3,
        actPayer = 4,
        actVendor = 5,
        actRecord = 6,
        actPharmacy = 7,
        actSubscriber = 8,
    }

    export enum offlineRecStatus {
        offlineLocked = -1,
        offlineNoChange = 0,
        offlineInsert = 1,
        offlineUpdate = 2,
        offlineDelete = 3,
    };

    export enum entity_type_qualifier {
        etqPerson = "1",
        etqNonPerson = "2",
    };

    export enum maritalstatus{
        msNone = 0,
        msSingle = 1,
        msMarried = 2,
        msWidowed = 3,
        msDivorced = 4,
        msSeparated = 5,
    };

    export enum addresstype {
        atHome = 0,
        atMailing = 1,
        atWork = 2,
        atOffice = 3,
        atCorporate = 4,
    };

    export enum contacttype{
        ctHome = 0,
        ctWork = 1,
        ctOffice = 2,
        ctCorporate = 3,
        ctCell = 4,
        ctOther = 5,
        ctFax = 6,
    };

    export enum LOGTYPE{
        ltNone = 0,
        ltWarning = 1,
        ltUserAlert = 2,
        ltMedicalAlert = 3,
        ltError = 4,
        ltFatal = 5,
        ltSecurity = 6,
        ltBusinessIntel = 7,
    };

    export enum recurringtype{
        recurtypeContinuous = -1,
        recurtypeOneTime = 0,
        recurtypeHourly = 1,
        recurtypeDaily = 2,
        recurtypeWeekly = 3,
        recurtypeDayWeekofMonth = 4,
        recurtypeMonthly = 5,
        recurtypeNumberofYears = 6,
        recurtypeYearly = 7,
        recurtypeDayWeekandMonthofYear = 8,
    };

    export enum recurringsubtype{
        recursubEveryHour = 1,
        recursubEveryDay = 2,
        recursubEveryWeekday = 3,
        recursubWeeklySunday = 4,
        recursubWeeklyMonday = 5,
        recursubWeeklyTuesday = 6,
        recursubWeeklyWednesday = 7,
        recursubWeeklyThursday = 8,
        recursubWeeklyFriday = 9,
        recursubWeeklySaturday = 10,
        recursubMonthlyTheD = 11,
        recursubMonthlyTheDay = 12,
        recursubYearlyTheD = 13,
        recursubYearlyTheDay = 14,
    };

    export enum thew{
        thewFirst = 1,
        thewSecond = 2,
        thewThird = 3,
        thewFourth = 4,
        thewLast = 5,
    };

    export enum theday{
        thedaySunday = 1,
        thedayMonday = 2,
        thedayTuesday = 3,
        thedayWednesday = 4,
        thedayThursday = 5,
        thedayFriday = 6,
        thedaySaturday = 7,
    };

    export enum trans_status{
        isError = 6000,
        isNone = 0,
        isReadyToSend = 1,
        isReadyToPrint = 2,
        isSent = 3,
        isReceived = 4,
        isTimeout = 5,
        isVoided = 6,
        isReSent = 7,
        isPrinted = 8,
        isDenied = 9,
        isPending = 10,
        isVerified = 11,
        isPaid = 12,
        isModified = 13,
        isRejected = 14,
        isAccepted = 15,
        isPaymentReceived = 16,
        isApproved = 17,
        isRead = 18,
        isUnRead = 19,
        isTentative = 20,
    };

    export enum TRANSTYPE{
      itNone = 0,
      itEligibility = 1,
      itEligibilityResponse = 2,
      itPreCertReferral = 3,
      itPreCertReferralResponse = 4,
      itClaimSubmission = 5,
      itClaimSubmissionResponse = 6,
      itClaimInquiry = 7,
      itClaimInquiryResponse = 8,
      itEFT = 9,
      itEFTResponse = 10,
      itCreditCard = 11,
      itCreditCardResponse = 12,
      itePrescribe = 13,
      itePrescribeResponse = 14,
      itHL7 = 15,
      itHL7Response = 16,
      itPrintClaim = 17,
      itPrintClaimResponse = 18,
      itERAResponse = 19,
      itPayPal = 20,
      itPayPalResponse = 21,
      itPatientStatement = 22,
      itPatientStatementResponse = 23,
      itPaperCheck = 24,
      itInvite = 25,
      itDashboardPost = 26,
      iteOrganizationDownload = 27,
      iteOrganizationDownloadResponse = 28,
      itePrescriptionRouting = 29,
      itePrescriptionRoutingResponse = 30,
      iteMedicationHistory = 31,
      iteMedicationHistoryResponse = 32,
      iteLab = 33,
      iteLabResponse = 34,
      itSurvey = 35,
      itSurveyResponse = 36,
      itAlarm = 37,
      itAlarmResponse = 38,
      iteDirectoryDownload = 39,
      iteDirectoryDownloadResponse = 40,
      iteAddUpdateProviderLocation = 41,
      iteAddUpdateProviderLocationResponse = 42,
      iteGetProviderLocation = 43,
      iteGetProviderLocationResponse = 44,
      iteDisableProviderLocation = 45,
      iteDisableProviderLocationResponse = 46,
      iteGetOrganization = 47,
      iteGetOrganizationResponse = 48,
      iteFormularyBenefitRequest = 49,
      iteFormularyBenefitResponse = 50,
    };

  export enum CONNECTIONTYPE {
    conntypNone = 0,
    conntypBatchMode = 1,
    conntypRealtime = 2,
    conntypGatewayUI = 3,
  };

  export enum PROTOCOL {
    protocolNone = 0,   //(SSH)
    protocolSFTP = 1,   //(SSH)
    protocolFTPS = 2,   //(SSL)
    protocolFTP = 3,    //(PGP)
    protocolHTTPS = 4,  // Multipart MIME
  };

  export enum PROTOCOLAPI {
    papiURL = 0,
    papiPutty = 1,
    papiMoveitFreely = 2,
  };

  export enum DATA_TRANSPORT_FORMAT {
    datatfmtNone = 0,
    datatfmtXML = 1,
    datatfmtHL7 = 2,
    datatfmtX12N = 3,
    datatfmtMultipartMIME = 4,
    datatfmtJson = 5,
  };

  export enum participation_type {
    pptNonParticipating = 0,
    pptParticipating = 1,
    pptParticipatingPlus = 2,
  };

    export enum SourceType{
        srcUndefined = 0,
        srcDiagnosis = 1,
        srcTypeOfService = 2,
        srcTestProcedure = 3,
        srcClinicalResults = 4,
        srcCare = 5,
        srcProcedure = 6,
        srcMedication = 7,
        srcReferral = 8,
        srcFamilyConference = 9,
        srcOther = 10,
        srcStatement = 11,
        srcPayment = 12,
        srcCoPay = 13,
        srcXRayRad = 14,
        srcPrescriptionRefill = 15,
        srcCareDetail = 16,
        srcEncounterNotes = 17,
        srcExam = 18,
        srcImmunization = 19,
        srcToothService = 20,
        srcToothPlan = 21,
        srcPatientDemographics = 22,
        srcService = 23,
        srcMiscellaneousForms = 24,
        srcImage = 25,
        srcTreatmentPlan = 26,
        srcERA = 27,
        srcPatientPhoto = 28,
        srcCCD = 29,
        srcAllergies = 30,
        srcVitals = 31,
        srcLast,
    };

    export enum EXTERNAL_DATA_TYPE{
            edtypeText = 0,
            edtypeJpeg = 1,
            edtypeGIF = 2,
            edtypePNG = 3,
            edtypeTiff = 4,
            edtypeBitmap = 5,
            edtypePDF = 6,
            edtypeMsword = 7,
            edtypeRAR = 8,
            edtypeMsexcel = 9,
            edtypePowerpoint = 10,
            edtypeICEMEDX = 11,
            edtypeMpeg = 12,
            edtypeMp4 = 13,
            edtypeWebm = 14,
            edtypeWmv = 15,
            edtypeWma = 16,
        };


    export enum ALERTTYPE {
        alertAll = -1,
        alertSystem = 0,
        alertMedication = 1,
        alertAdverseInteraction = 2,
        alertOrder = 3,
        alertNotification = 4,
        alertDiagnosis = 5,
        alertVitals = 6,
        alertDiseaseManagement = 7,
        alertWellnessManagement = 8,
        alertPreventiveManagement = 9,
        alertHealthLiteracy = 10,
        alertSurvey = 11,
        alertContraIndication
    };

    export enum GENDER{
        male = "M",
        female = "F",
        unknown = "U",
    };

    export enum task_type{
        tasktypePatient = 1,
        tasktypeAccounting = 2,
        tasktypeSchedule = 3,
        tasktypeChore = 4,
        tasktypeAdmissionDischarge = 5,
        tasktypeCallback = 6,
        tasktypeOther = 7,
        tasktypePatientIntake = 8,
        tasktypePatientAccessRequest = 9,
        tasktypeReferral = 10,
        tasktypeAppointmentDetails = 11,
        tasktypeInstructions = 12,
    };

    export enum appt_type{
        appttypeInitial = 1,
        appttypeFollowup = 2,
        appttypeOther = 3,
        appttypeClosed = 4,
        appttypeUnAvailable = 5,
    };

    export enum appt_status{
        apptstatNone = 0,
        apptstatCancelled = 1,
        apptstatComingUp = 2,
        apptstatArrived = 3,
        apptstatWaiting = 4,
        apptstatWithStaff = 5,
        apptstatReady = 6,
        apptstatComplete = 7,
        apptstatReschedule = 8,
    };

    export enum interval{
        interval15 = 15,
        interval30 = 30,
    };

    export enum duration{
        durationNone = 0,
        duration15 = 15,
        duration30 = 30,
        duration45 = 45,
        duration60 = 60,
        duration75 = 75,
        duration90 = 90,
        duration105 = 105,
        duration120 = 120,
        duration135 = 135,
        duration150 = 150,
        duration165 = 165,
        duration180 = 180,
  };

  export enum ReportType {
    rtUndefined = 0,
    rtClincialData = 1,
    rtScheduling = 2,
    rtAccountingSummary = 3,
    rtMedicalCodes = 4,
    rtOther = 5
  };

  export enum MessageboxTypes {
    mboxINBOX = "0",
    mboxOUTBOX = "1",
    mboxSENT = "2",
    mboxDRAFTS = "3",
    mboxINVITE = "4",
    mboxPOSTS = "5",
    mboxTRANSBOX = "6",
    mboxDELETED = "7",
    mboxPROCESSED = "8",
  }

  export enum problemstate {
    stateCurrent = 0,
    statePast = 1,
  }

  export enum problemstatus {
    statusActive = 0,
    statusResolved = 1,
  }

  export enum notestatus {
    statusInitialDraft = 0,
    statusInProgress = 1,
    statusComplete = 2,
    statusCompleteRequired = 3,
    statusPatientCompleteRequired = 4,
  }

  export enum orderentrystatus {
    oestatusComplete = 0,
    oestatusWaiting = 1,
    oestatusRendered = 2,
    oestatusPartiallyRendered = 3,
    oestatusNotRendered = 4,
    oestatusCancelled = 5,
    oestatusInprogress = 6,
    oestatusOnhold = 7,
    oestatusIncomplete = 8,
    oestatusAuthorizationRequired = 9,
    oestatusApproved = 10,
    oestatusRefused = 11,
    oestatusHighPriority = 12,
    oestatusSignatureRequired = 13,
    oestatusVerbalOrder = 14,
    oestatusDenied = 15,
    oestatusApprovedWithChanges = 16,
    oestatusDeniedNewPrescriptionToFollow = 17,
    oestatusTransactionPending = 18,
    oestatusTransactionError = 19,
    oestatusTransactionAccepted = 20,
    oestatusTransactionReceivedWithError = 21,
    oestatusCancelPending = 22,
    oestatusCancelError = 23,
    oestatusCancelApproved = 24,
    oestatusFollowUpRequest = 25,
    oestatusFillIndicator = 26,
    oestatusCancelDenied = 27,
    oestatusTransferred = 28,
  }

  export enum activitytype {
    atRender = 0,
    atOrder = 1,
    atPrescribe = 3,
    atRenewalRequest = 4,
    atDispensed = 5,
    atObservationComments = 6,
    atRenewalResponse = 7,
    atRenderStart = 8,
    atRenderEnd = 9,
    atModified = 10,
    atObservationResults = 11,
    atCancelRequest = 12,
    atCancelResponse = 13,
    atChangeRequest = 14,
    atChangeResponse = 15,
    atFillIndicatorChangeRequest = 16,
    atProposedOrRecommendedChange = 17,
  }

  export enum guidelinetype {
    gdetypeDisease = 0,
    gdetypeWellness = 1,
    gdetypePreventive = 2,
  }

  export enum observationtype {
    observTypeSymptom = 0,
    observTypePatientAnnotations = 1,
    observTypePatientAwareness = 2,
    observTypeEpisode = 3,
    observTypePrecondition = 4,
    observTypeMedicationStatus = 5,
    observTypeReaction = 6,
    observTypeStatusChange = 7,
    observTypeResult = 8,
    observTypeNote = 9,
    observTypeVitals = 10,
    observTypeAllergies = 11,
  }
  export enum severitytype {
    servTypeUnknown = 0,
    servTypeMild = 1,
    servTypeIntensive = 2,
    servTypeCritical = 3,
    servTypeNonCritical = 4,
  }
  export enum medicationstate {
    medstateCurrent = 0,
    medstatePast = 1,
    medstateInActive = 3,
    medstateErrorneous = 4,
    medstateCompleted = 5,
    medstateDiscontinued = 6,
  }

  export enum DATE_FORMATS {
    default = 0,
    mm_dd_yyyy = 1,
    dd_mm_yyyy = 2,
    yyyy_mm_dd = 3,
  }

  export enum RegistrationTopics {
    rtConsult = "consult",
    rtFollowup = "followup",
    rtSick = "sick",
    rtPregnant = "pregnant",
    rtCancer = "cancer",
    rtDiabetic = "diabetic",
    rtHIV = "hiv",
    rtCOVID19 = "covid19",
    rtMultiple = "multiple",
    rtPracticeDoctor = "doctor",
    rtPracticeAdministrator = "administrator",
    rtPracticeIT = "IT",
    rtVendorHIE = "vendorHIE",
    rtPharmacy = "pharmacy",
    rtPayer = "payer",
    rtSubscriber = "subscriber",
  }

  export enum RESULT_STATUS {
    rsPending = "O",
    rsCorrected = "C",
    rsNoVerified = "R",
    rsPartial = "S",
    rsFinal = "F",
    rsNotObserved = "N",
    rsPreliminary = "P",
    rsResultNotPossible = "X",
  }

  export enum TYPEOFRANGE {
    torInside = 0,
    torOutside = 1,
  };

  export enum coa_types {
    coaNone = 0,
    // Assets
    coaAsset = 1000,
    coaCashPrimary = 1010,
    coaCashSecondary = 1020,
    coaCashPetty = 1030,

    coaAR = 1110,
    coaCoPayAR = 1120,
    coaCoInsuranceAR = 1121,
    coaDeductibleAR = 1122,
    coaSupplies = 1210,
    coaOfficeEquipment = 1310,
    coaInventory = 1410,

    // Revenue
    coaRevenue = 2000,
    coaCoPayIncome = 2010,
    coaDeductibleIncome = 2020,
    coaServiceIncome = 2030,
    coaOtherIncome = 2040,
    coaCoInsuranceIncome = 2050,

    // Expense
    coaExpense = 3000,
    coaCostofSuppliesExpense = 3020,
    coaRentExpense = 3030,
    coaUtilitiesExpense = 3040,
    coaMiscellaneousExpense = 3050,
    coaCostofServiceExpense = 3060,
    coaCostofInventoryExpense = 3070,

    coaDiscount = 3110,
    coaClaimAdjustment = 3120, // Other adjustments
    coaDisallowedAdjustment = 3121,
    coaContractualObligationsAdjustment = 3122,
    coaCorrectionandReversalsAdjustment = 3123,

    coaSalesTaxExpense = 3210,
    coaIncomeTaxExpense = 3220,
    coaPayrollTaxExpense = 3230,

    coaSalaryExpense = 3310,
    coaCommissionExpense = 3320,
    coaVacationExpense = 3330,
    coaSalaryReimbursementExpense = 3340,

    // Liabilities
    coaLiabilities = 4000,
    coaAP = 4110,
    coaNotesPayable = 4120,

    coaSalesTaxPayable = 4210,
    coaIncomeTaxPayable = 4220,
    coaPayrollTaxPayable = 4230,

    coaSalaryPayable = 4310,
    coaCommissionPayable = 4320,
    coaVacationPayable = 4330,
    coaSalaryReimbursementPayable = 4340,

    // Capital / Equ
    coaEquity = 5000,
    coaOwnersCapital = 5010,
    coaOwnersDrawing = 5020,
  };

  export enum InventoryMethod {
    imFIFO = 0,
    imLIFO = 1,
    imWeightedAverage = 2
  };

  export enum sales_tax_status {
    stsTaxable = 1,
    stsNonTaxable = 2,
  };

  export enum RATEUNITS {
    ruPerDay = 1,
    ruPerWeek = 2,
    ruPerMonth = 3,
    ruPerYear = 4,
    ruPerHalfYear = 5,
  };

  export enum LIMITTYPE {
    ltNone = 0,
    ltUser = 1,
    ltPatient = 2,
    ltTransaction = 3,
    ltData = 4,
    ltProvider = 5,
  };

  export enum unit_type {
    utypeUnknown = 0,
    utypeEach = 1,
    utypeBox,
    utypePackage,
    utypeRoll,
  };

  export enum PatientSearchType {
    ptSearchKeyword = "",
    ptSearchLastName = "bylastname",
    ptSearchContact = "bycontact",
    ptSearchDOB = "bydob",
  }

  export enum JournalType {
    jtAll = "",
    jtAsset = "ASSET",
    jtExpense = "EXPENSE",
    jtIncome = "INCOME",
    jtLiability = "LIABILITY",
    jtInventory = "INVENTORY",
    jtPostings = "POSTINGS",
  }

  export enum basis_of_accounting {
    boaCash = 0, 
    boaAccrual = 1, 
  };

  export enum period_status {
    psCreated = 0,
    psStarted = 1,
    psPaused = 2,
    psFinished = 10
  };

  export enum journal_entry_type {
    jetGeneral = 0,
    jetModified = 1,
    jetManual = 2,
    jetClosing = 3,
    jetManualClosing = 4,
    jetImported = 5
  };

  export enum RecordActionType {
    oatEdit = 0,
    oatView = 1,
    oatRemove = 2,
    oatJoinMeeting = 3,
    oatSend = 4,
    oatCloudDownload = 5,
    oatViewBucket = 6,
    oatViewBalance = 7,
    oatViewHistory = 8,
  };

  export const recordQuickActionEdit = { name: "Edit", value: RecordActionType.oatEdit, iconClass: { "fas": true, "fa-edit": true, "fa-2x": true } };
  export const recordQuickActionRemove = { name: "Remove", value: RecordActionType.oatRemove, iconClass: { "fas": true, "fa-trash": true, "fa-2x": true } };
  export const recordQuickActionView = { name: "View", value: RecordActionType.oatView, iconClass: { "fas": true, "fa-file-alt": true, "fa-2x": true } };
  export const recordQuickActionViewBucket = { name: "View Bucket", value: RecordActionType.oatViewBucket, iconClass: { "fas": true, "fa-shopping-basket": true, "fa-2x": true } };
  export const recordQuickActionViewBalance = { name: "View Balance", value: RecordActionType.oatViewBalance, iconClass: { "fas": true, "fa-file-alt": true, "fa-2x": true } };
  export const recordQuickActionViewHistory = { name: "View History", value: RecordActionType.oatViewHistory, iconClass: { "fas": true, "fa-history": true, "fa-2x": true } };
  export const recordQuickActionJoinMeeting = { name: "Join", value: RecordActionType.oatJoinMeeting, iconClass: { "fas": true, "fa-video": true, "fa-2x": true } };
  export const recordQuickActionSend = { name: "Send", value: RecordActionType.oatSend, iconClass: { "fas": true, "fa-paper-plane": true, "fa-2x": true } };
  export const recordQuickActionCloudDownload = { name: "Cloud Download or Sync.", value: RecordActionType.oatCloudDownload, iconClass: { "fas": true, "fa-cloud-download-alt": true, "fa-2x": true } };

  export enum ServiceLevel {
    svcLevelNone = 0,
    svcLevelNew = 1,
    svcLevelRefill,
    svcLevelChange,
    svcLevelRxFill,
    svcLevelCancel,
    svcLevelMedHistory,
    svcLevelReSupp,
    svcLevelCensus,
    svcLevelCCR,
    svcLevelControlledSubstance,
    svcLevelCIMessage,
    svcLevelCIEvent,
    svcLevelePA,
    svcLevelLongTermCare,
    svcLevelRxFillIndicatorChange,
    svcLevelDrugAdministration,
    svcLevelNewRxRequest,
    svcLevelNewRxResponseDenied,
    svcLevelRecertification,
    svcLevelPatMedBenefitCheck,
    svcLevelSpecialty,
    svcLevelRxTransfer,
    svcLevelSPOAutoEnrollment,
  };

  export enum BenefitCodes {
    bcActiveCoverage = "1",
    bcInactive = "6",
    bcCannotProcess = "V",
    bcOutofPocket = "G",
    bcNonCovered = "I",
    bcCoinsurance = "A",
    bcCopayment = "B",
    bcDeductible = "C",
    bcContactEntity = "U",
    bcPCPInfo = "L",
    bcBenefitLimits = "F",
  };

  export enum OPTION_KEYS
  {
    APPOINTMENT_STARTTIME = "APPOINTMENT_STARTTIME",
    APPOINTMENT_DURATION = "APPOINTMENT_DURATION",
    APPOINTMENT_FORECOLOR =  "APPOINTMENT_FORECOLOR",
    APPOINTMENT_BACKCOLOR =  "APPOINTMENT_BACKCOLOR",
    SCHEDULE_BEGINS = "SCHEDULE_BEGINS",
    SCHEDULE_ENDS = "SCHEDULE_ENDS",
    SCHEDULE_INTERVAL = "SCHEDULE_INTERVAL",
    SCHEDULE_UNAVAILABLE_DAYS = "SCHEDULE_UNAVAILABLE_DAYS",
    SCHEDULE_DEFAULT_SEARCHDAYS = "SCHEDULE_DEFAULT_SEARCHDAYS",
    PAGE_DEFAULT = "PAGE_DEFAULT",
    DEFAULT_COUNTRY = "DEFAULT_COUNTRY",
    DEFAULT_CURRENCY = "DEFAULT_CURRENCY",
    DEFAULT_TIMEZONE = "DEFAULT_TIMEZONE",
    CITYLOCALITY = "CITYLOCALITY",
    STATELOCALITY = "STATELOCALITY",
    PROVINCELOCALITY = "PROVINCELOCALITY",
    WEBSESSION_TIMEOUT = "WEBSESSION_TIMEOUT",
    APPSESSION_TIMEOUT = "APPSESSION_TIMEOUT",
    PRACTICE_POLICIES_NOTICES = "PRACTICE_POLICIES_NOTICES",
    APPOINTMENT_TYPES = "APPOINTMENT_TYPES",
    APPOINTMENT_FEE_REQUIREMENTS = "APPOINTMENT_FEE_REQUIREMENTS",
    APPOINTMENT_FEE_REQUIRED = "APPOINTMENT_FEE_REQUIRED",
    SCHEDULECHANGENOTIFY_USERS = "SCHEDULECHANGENOTIFY_USERS",
    SCHEDULECHANGENOTIFY = "SCHEDULECHANGENOTIFY",
    SCHEDULEREMINDERNOTIFY_USERS = "SCHEDULEREMINDERNOTIFY_USERS",
    SCHEDULEREMINDERNOTIFY = "SCHEDULEREMINDERNOTIFY",
    DATEFORMAT_LOCALITY = "DATEFORMAT_LOCALITY",
    LABORATORY = "LABORATORY",
    PHARMACY = "PHARMACY",
  };

  export const LanguageMap = {
    "GB": {
      locale: "en-GB",
      dateFormat: "dd/MM/yyyy"
    },
    "US": {
      locale: "en-US",
      dateFormat: "MM/dd/yyyy"
    },
    "IN": {
      locale: "en-IN",
      dateFormat: "dd/MM/yyyy"
    },
    "NG": {
      locale: "ig-NG",
      dateFormat: "dd/MM/yyyy"
    }
  }

  export const ReturnToOffice =
  {
    rto1_2Days: { value: 1, name: "1-2 Days" },
    rto2_5Days: { value: 2, name: "2-5 Days" },
    rto6_Days: { value: 3, name: "6 Days" },
    rto1_Week: { value: 4, name: "1 Week" },
    rto10_Days: { value: 5, name: "10 Days" },
    rto2_Weeks: { value: 6, name: "2 Weeks" },
    rto3_Weeks: { value: 7, name: "3 Weeks" },
    rto1_Month: { value: 8, name: "1 Month" },
    rto2_Months: { value: 9, name: "2 Months" },
    rto3_Months: { value: 10, name: "3 Months" },
    rto4_Months: { value: 11, name: "4 Months" },
    rto5_Months: { value: 12, name: "5 Months" },
    rto6_Months: { value: 13, name: "6 Months" },
    rto7_Months: { value: 14, name: "7 Months" },
    rto8_Months: { value: 15, name: "8 Months" },
    rto9_Months: { value: 16, name: "9 Months" },
    rto10_Months: { value: 17, name: "10 Months" },
    rto11_Months: { value: 18, name: "11 Months" },
    rto1_Year: { value: 19, name: "1 Year" },
    rto2_Years: { value: 20, name: "2 Years" },
    rtoAsNeeded: { value: 21, name: "As Needed" },
    rtoProcedure: { value: 22, name: "Procedure" },
    rtoNone: { value: 23, name: "None" },
    rto6_Weeks: { value: 24, name: "6 Weeks" },
    rto10_Weeks: { value: 25, name: "10 Weeks" },
    rtoOther: { value: 26, name: "Other" },
    rtoAdmit: { value: 27, name: "Admit to Ward" },
  };

  export const NoteStatus = {
    statusInitialDraft: { value: 0, name: "Initial Draft" },
    statusInProgress: { value: 1, name: "In Progress" },
    statusComplete: { value: 2, name: "Complete" },
    statusCompleteRequired: { value: 3, name: "Complete Required" },
    statusPatientCompleteRequired: { value: 4, name: "Patient Required to Complete" }
  }

  export const EXTERNAL_DATA_TYPE_MAP =
  {
    edtypeText: { value: 0, name: "Text" },
    edtypeJpeg: { value: 1, name: "Jpeg" },
    edtypeGIF: { value: 2, name: "GIF" },
    edtypePNG: { value: 3, name: "PNG" },
    edtypeTiff: { value: 4, name: "Tiff" },
    edtypeBitmap: { value: 5, name: "Bitmap" },
    edtypePDF: { value: 6, name: "PDF" },
    edtypeMsword: { value: 7, name: "Msword" },
    edtypeRAR: { value: 8, name: "RAR" },
    edtypeMsexcel: { value: 9, name: "Msexcel" },
    edtypePowerpoint: { value: 10, name: "Powerpoint" },
    edtypeICEMEDX: { value: 11, name: "IceX" },
    edtypeMpeg: { value: 12, name: "Mpeg" },
    edtypeMp4: { value: 13, name: "Mp4" },
    edtypeWebm: { value: 14, name: "Webm" },
    edtypeWmv: { value: 15, name: "Wmv" },
    edtypeWma: { value: 16, name: "Wma" }
  };
}
